import {DateTime} from "luxon";

export class DateUtil {
    public static getRelativeTime(unixTimeStampInMs: string): string {
        if (unixTimeStampInMs) {
            return DateTime.fromMillis(Number(unixTimeStampInMs))?.toRelative();
        } else {
            return null;
        }
    }

    public static convertLocalDateTimeToUTC(utcDate: string, timeString: string): Date {
        const newUtcDate = new Date(utcDate);
        const [time, modifier] = timeString.split(' ');
        let [hours, minutes] = time.split(':').map(Number);
        if (modifier === 'PM' && hours < 12) hours += 12;
        if (modifier === 'AM' && hours === 12) hours = 0;
        const year = newUtcDate.getUTCFullYear();
        const month = newUtcDate.getUTCMonth();
        const day = newUtcDate.getUTCDate();
        const localDateTime = new Date(year, month, day, hours, minutes, 0, 0);
        return new Date(localDateTime.getTime());
    }

    public static extractDate(dateTime: string): Date | null {
        return dateTime ? new Date(dateTime) : null;
    }

    public static extractDatePickerValue(dateTime: string): Date | null {
        return dateTime ? this.toDatePickerValue(new Date(dateTime)) : null;
    }

    public static toDatePickerValue(date: Date): Date {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    }

    public static fromDatePickerValue(datePickerValue: Date): Date {
        return new Date(datePickerValue.getUTCFullYear(), datePickerValue.getUTCMonth(), datePickerValue.getUTCDate());
    }

    public static extractTimeLabel(dateTime: string): string | null {
        if (!dateTime) {
            return null;
        }
        const date = new Date(dateTime);
        const modifier = date.getHours() >= 12 ? 'PM' : 'AM';
        const hours = date.getHours() % 12 || 12;
        return `${this.padToTwoDigits(hours)}:${this.padToTwoDigits(date.getMinutes())} ${modifier}`;
    }

    private static padToTwoDigits(value: number): string {
        return String(value).padStart(2, '0');
    }
}
